import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import {
	ADMIN_SPACE_PERMISSIONS,
	ADMIN_EDIT_SPACE_PERMISSIONS,
	SPACE_PERMISSION,
	SPACE_RESTRICTED_PAGES,
	ADMIN_AUDIT_LOG,
} from '@confluence/named-routes';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';

import { ChangeEditionSectionMessageAdminSpace } from '../SectionMessage/ChangeEditionSectionMessageAdminSpace';
import { ChangeEditionSectionMessageAuditLogs } from '../SectionMessage/ChangeEditionSectionMessageAuditLogs';
import { ChangeEditionSectionMessageSpace } from '../SectionMessage/ChangeEditionSectionMessageSpace';
import { ChangeEditionSectionMessageSpaceContent } from '../SectionMessage/ChangeEditionSectionMessageSpaceContent';

export const FREE_SECTION_MESSAGE_COMPONENT_PLACEHOLDER_ID =
	'confluence-change-edition-section-message';
export class ChangeEditionSectionMessageLegacyCoordinator extends Component {
	el = window.document.getElementById(FREE_SECTION_MESSAGE_COMPONENT_PLACEHOLDER_ID);

	ROUTE_NAME2COMPONENT = {
		[ADMIN_SPACE_PERMISSIONS.name]: ChangeEditionSectionMessageAdminSpace,
		[ADMIN_EDIT_SPACE_PERMISSIONS.name]: ChangeEditionSectionMessageAdminSpace,
		[SPACE_PERMISSION.name]: ChangeEditionSectionMessageSpace,
		[SPACE_RESTRICTED_PAGES.name]: ChangeEditionSectionMessageSpaceContent,
		[ADMIN_AUDIT_LOG.name]: ChangeEditionSectionMessageAuditLogs,
	};

	isSectionMessageNeeded(routeName) {
		return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
	}

	getComponentParams(routeName) {
		if (routeName === SPACE_PERMISSION.name) {
			return {
				grandfathered: this.el.getAttribute('data-grandfathered') === 'true',
				canClear: this.el.getAttribute('data-can-clear') === 'true',
				spaceName: this.el.getAttribute('data-space-name'),
				spaceKey: this.el.getAttribute('data-space-key'),
			};
		} else if (routeName === SPACE_RESTRICTED_PAGES.name) {
			return {
				grandfathered: this.el.getAttribute('data-grandfathered') === 'true',
			};
		}

		return {};
	}

	render() {
		if (!this.el) {
			return null;
		}

		return (
			<RoutesContext.Consumer>
				{({ location, matchRoute }) => {
					const routeName = matchRoute(location.pathname + location.search);

					if (!this.isSectionMessageNeeded(routeName)) {
						return null;
					}

					const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];

					return ReactDOM.createPortal(
						<ChangEditionComponent {...this.getComponentParams(routeName.name)} />,
						this.el,
					);
				}}
			</RoutesContext.Consumer>
		);
	}
}
